import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.core.common.FlexibleIdentifier<string>,
  graphql.schema.FlexibleIdentifierInput
>({
  alias: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
})
